import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { LimitePagamentoEcgPorTerceirosCadastroComponent } from "./cadastro/limite-pagamento-ecg-por-terceiros-cadastro.component";
import { LimitePagamentoEcgPorTerceirosRoutingModule } from "./limite-pagamento-ecg-por-terceiros-routing.module";
import { LimitePagamentoEcgPorTerceirosPesquisaComponent } from './pesquisa/limite-pagamento-ecg-por-terceiros-pesquisa/limite-pagamento-ecg-por-terceiros-pesquisa.component';
import { LimitePagamentoEcgTerceiroService } from "./limite-pagamento-ecg-terceiro.service";
import { LimitePagamentoEcgPorTerceirosListagemComponent } from "./pesquisa/limite-pagamento-ecg-por-terceiros-pesquisa/listagem/limite-pagamento-ecg-por-terceiros-listagem/limite-pagamento-ecg-por-terceiros-listagem.component";
import { LimitePagamentoEcgPorTerceirosHistoricoComponent } from "./historico/limite-pagamento-ecg-por-terceiros-historico.component";


@NgModule({
  imports: [
    SharedModule,
    BrowserModule,
    CommonModule,
    LimitePagamentoEcgPorTerceirosRoutingModule,
  ],
  exports: [],
  declarations: [
    LimitePagamentoEcgPorTerceirosCadastroComponent,
    LimitePagamentoEcgPorTerceirosPesquisaComponent,
    LimitePagamentoEcgPorTerceirosListagemComponent,
    LimitePagamentoEcgPorTerceirosHistoricoComponent,
  ],
  providers: [LimitePagamentoEcgTerceiroService],
  schemas: [],
})
export class LimitePagamentoEcgPorTerceirosModule {}
